import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const Zendesk = (props: TIconProps): ReactElement => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <polygon
      id="zendesk_group_3_"
      fill="hsl(from hsl(187 90% 13%) h s 50%)"
      points="11.1,8.6 11.1,21.1 0.7,21.1 "
    />
    <path
      id="zendesk_group_2_"
      fill="hsl(from hsl(187 90% 13%) h s 50%)"
      d="M11.1,4.1c0,2.9-2.3,5.2-5.2,5.2S0.7,7,0.7,4.1H11.1z"
    />
    <path
      id="zendesk_group_1_"
      fill="hsl(from hsl(187 90% 13%) h s 50%)"
      d="M12.8,21.1c0-2.9,2.3-5.2,5.2-5.2s5.2,2.3,5.2,5.2H12.8z"
    />
    <polygon
      id="zendesk_group"
      fill="hsl(from hsl(187 90% 13%) h s 50%)"
      points="12.8,16.6 12.8,4.1 23.2,4.1 12.8,16.6 "
    />
  </svg>
);
